import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { portalAction, portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { Box, Button, Grid, Paper } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import EventsFormModel from "../../app/models/events/eventsFormModel";
import AppPcsEventSwitchField from "./common/AppPcsEventSwitchField";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { gePcsEventByIdAsync, submitPcsEventAsync } from "../../app/slices/pcsEventSlice";
import { toast } from "react-toastify";
import { API_REQUEST_FULLFILLED, MESSAGE_DETAILS_SAVED, MESSAGE_PROCESSING_DETAILS } from "../../app/utils/constant";
import { ApiRequestStatus } from "../../app/enums/apiRequestStatus";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useHistory } from "react-router-dom";
import { AppPathEnum } from "../../app/enums/appPathEnum";

const {
    LeadOrganiserNotEmployeeOfIndustrySponsor, ProgrammeDevelopedByLeadOrganiser, ContentOfAllAspectsOfEventWillBeFree,
    AllRelevantFinancialRelationships, DeclarationsOfConflictsOfInterest, ParticipantsInThisActivityToProvide,
    AllParticipantsInWithClearEvidence, LearnersWillBeInformed, ApplicationConformsToTheRCSIGuidelines, BreachOfGuidelines
} = EventsFormModel.declarationFormField;

interface Props {
    isSpaEditabe: boolean;
    handleBack: () => void;
}

export default function Declaration({ isSpaEditabe, handleBack }: Props) {
    const methods = useForm({
        mode: 'all'
    });
    methods.watch();
    const { control, getValues, reset } = methods;
    const { pcsEventDetails, getPcsEventStatus, submitPcsEventStatus } = useAppSelector(state => state.pcsEvent);

    const history = useHistory();

    useEffect(() => {
        reset({
            [LeadOrganiserNotEmployeeOfIndustrySponsor.name]: false,
            [ProgrammeDevelopedByLeadOrganiser.name]: false,
            [ContentOfAllAspectsOfEventWillBeFree.name]: false,
            [AllRelevantFinancialRelationships.name]: false,
            [DeclarationsOfConflictsOfInterest.name]: false,
            [ParticipantsInThisActivityToProvide.name]: false,
            [AllParticipantsInWithClearEvidence.name]: false,
            [LearnersWillBeInformed.name]: false,
            [ApplicationConformsToTheRCSIGuidelines.name]: false,
            [BreachOfGuidelines.name]: false
        });
    }, [reset]);

    const dispatch = useAppDispatch();

    const saveDetails = async () => {
        pcsEventDetails?.eventId && dispatch(submitPcsEventAsync(pcsEventDetails?.eventId))
            .then((response) => {
                if (response.meta.requestStatus.toLowerCase() === API_REQUEST_FULLFILLED) {
                    pcsEventDetails?.eventId && dispatch(gePcsEventByIdAsync(pcsEventDetails?.eventId));
                    toast.success(MESSAGE_DETAILS_SAVED);
                    history.push(`${AppPathEnum.EVENT_SUBMIT_SUCCESS_URI}${window.location.search}`);
                }
            });
    }

    usePortalScreen(portalScreenContext('Declaration'), undefined, !(submitPcsEventStatus === ApiRequestStatus.Pending || getPcsEventStatus === ApiRequestStatus.Pending));

    if (submitPcsEventStatus === ApiRequestStatus.Pending || getPcsEventStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return <FormProvider {...methods}>
        <Box sx={{ minWidth: "100%" }} component={Paper}>
            <Grid container rowSpacing={4} sx={{ ml: '2%' }}>
                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={LeadOrganiserNotEmployeeOfIndustrySponsor.name}
                        label={LeadOrganiserNotEmployeeOfIndustrySponsor.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={ProgrammeDevelopedByLeadOrganiser.name}
                        label={ProgrammeDevelopedByLeadOrganiser.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={ContentOfAllAspectsOfEventWillBeFree.name}
                        label={ContentOfAllAspectsOfEventWillBeFree.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={AllRelevantFinancialRelationships.name}
                        label={AllRelevantFinancialRelationships.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={DeclarationsOfConflictsOfInterest.name}
                        label={DeclarationsOfConflictsOfInterest.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={ParticipantsInThisActivityToProvide.name}
                        label={ParticipantsInThisActivityToProvide.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={AllParticipantsInWithClearEvidence.name}
                        label={AllParticipantsInWithClearEvidence.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={LearnersWillBeInformed.name}
                        label={LearnersWillBeInformed.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={ApplicationConformsToTheRCSIGuidelines.name}
                        label={ApplicationConformsToTheRCSIGuidelines.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppPcsEventSwitchField control={control} name={BreachOfGuidelines.name}
                        label={BreachOfGuidelines.label} defaultValue={false} disabled={isSpaEditabe} />
                </Grid>

                <Grid size={{ xs: 5 }} sx={{ textAlign: 'start' }}>
                    <Button variant="outlined" color="primary" onClick={portalAction(portalScreenContext('Declaration'), 'Declaration.onClick.handleBack', handleBack)}>
                        Back to previous step
                    </Button>
                </Grid>

                <Grid size={{ xs: 6 }} sx={{ textAlign: 'end' }}>
                    <Button variant="contained" color="primary" onClick={portalAction(portalScreenContext('Declaration'), 'Declaration.onClick.saveDetails', saveDetails)}
                        disabled={!(getValues(LeadOrganiserNotEmployeeOfIndustrySponsor.name)?.toString() === 'true' &&
                            getValues(ProgrammeDevelopedByLeadOrganiser.name)?.toString() === 'true' &&
                            getValues(ContentOfAllAspectsOfEventWillBeFree.name)?.toString() === 'true' &&
                            getValues(AllRelevantFinancialRelationships.name)?.toString() === 'true' &&
                            getValues(DeclarationsOfConflictsOfInterest.name)?.toString() === 'true' &&
                            getValues(ParticipantsInThisActivityToProvide.name)?.toString() === 'true' &&
                            getValues(AllParticipantsInWithClearEvidence.name)?.toString() === 'true' &&
                            getValues(LearnersWillBeInformed.name)?.toString() === 'true' &&
                            getValues(ApplicationConformsToTheRCSIGuidelines.name)?.toString() === 'true' &&
                            getValues(BreachOfGuidelines.name)?.toString() === 'true')
                        }>
                        Submit
                    </Button>
                </Grid>

                <Grid size={{ xs: 1 }}></Grid>

                <Grid size={{ xs: 12 }}></Grid>
            </Grid>
        </Box>
    </FormProvider>
}
